import React, { FC, ReactNode } from 'react'

import TableContainer from '@mui/material/TableContainer'
import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import Typography from '@mui/material/Typography'
import Box from '@mui/material/Box'
import Paper from '@mui/material/Paper'

import { makeStyles } from '@mui/styles'

import {
  TableSchema,
} from '../../../types/frontend/app'

const useStyles = makeStyles(theme => ({
}))

interface SimpleTableProps {
  data: Record<string, any>[],
  fields: TableSchema,
  actionsFieldClassname?: string,
  rowTextVariant?: 'h1' | 'h2' | 'h3' | 'h4' |'h5' | 'h6' | 'body1' | 'body2',
  hideHeaderIfEmpty?: boolean,
  hideHeader?: boolean,
  getActions?: {
    (row: Record<string, any>): ReactNode,
  },
  onRowClick?: {
    (row: Record<string, any>): void,
  },
}

const SimpleTable: FC<React.PropsWithChildren<SimpleTableProps>> = ({
  data,
  fields,
  getActions,
  onRowClick,
  hideHeaderIfEmpty,
  hideHeader,
  actionsFieldClassname,
  rowTextVariant = 'body2',
}) => {

  return (
    <Box
      sx={{
        width: '100%',
      }}
    >
      <Box
        sx={{
          overflowX: 'auto',
          boxShadow: '0 2px 4px 0px rgba(0,0,0,0.2)',
          borderRadius: '12px',
        }}
      >
        <TableContainer
           sx={{
            maxHeight: '74vh',
          }}
          component={Paper}
        >
          <Table>
            {
              (!hideHeader && (!hideHeaderIfEmpty || data.length > 0)) && (
                <TableHead
                  sx={{
                    backgroundColor: 'primary.main',
                    position: 'sticky',
                    top: 0,
                  }}
                  style={{
                    color: 'white',
                  }}
                >
                  <TableRow>
                    {
                      fields.map((field, i) => {
                        const style: any = {}
                        if(field.width) {
                          style.width = `${field.width}px`,
                          style.color = 'white'
                        }
                        return (
                          <TableCell
                            style={ style }
                            key={ i }
                            align={ field.numeric ? 'right' : 'left' }
                            sx={{
                              color: 'white',
                              p: 2,
                            }}
                          >
                            { field.title }
                          </TableCell>
                        )
                      })
                    }
                    {
                      getActions ? (
                        <TableCell
                          align='right'
                          sx={{
                            color: 'white',
                          }}
                        >
                          Actions
                        </TableCell>
                      ) : null
                    }
                  </TableRow>
                </TableHead>
              )
            }
            <TableBody>
              {data.map((dataRow, i) => {
                return (
                  <TableRow
                    hover
                    onClick={e => {
                      if(!onRowClick) return
                      onRowClick(dataRow)
                    }}
                    tabIndex={-1}
                    key={ i }
                  >
                    {
                      fields.map((field, i) => {
                        return (
                          <TableCell 
                            key={ i } 
                            align={ field.numeric ? 'right' : 'left' } 
                            sx={{
                              width: 'auto',
                              height: 'auto',
                            }}
                            className={ field.className }
                          >
                            <Typography
                              component="div"
                              variant={ rowTextVariant }
                            >
                              { dataRow[field.name] }
                            </Typography>
                          </TableCell>
                        )
                      })
                    }
                    {
                      getActions ? (
                        <TableCell align='right' className={ actionsFieldClassname }>
                          { getActions(dataRow) }
                        </TableCell>
                      ) : null
                    }
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>
      </Box>
    </Box>
  )
}

export default SimpleTable